import Vue from 'vue';
import i18n from '@/i18n';

export const EVENTS = {
  SHOW_TOOL_TIP: 'SHOW_TOOL_TIP',
  DESTROY_TOOLTIP: 'DESTROY_TOOLTIP',
  RENDER_SELECTED_CROP: 'RENDER_SELECTED_CROP',
  RE_RENDER_CROP: 'RE_RENDER_CROP',
  TOGGLE_EDIT_MODE: 'TOGGLE_EDIT_MODE',
  TOGGLE_SKU_BY_TYPE: 'TOGGLE_SKU_BY_TYPE',
  ZOOM_END: 'ZOOM_END',
  IMAGE_SET_CHANGED: 'IMAGE_SET_CHANGED',
  BACKGROUND_ALPHA_CHANGED: 'BACKGROUND_ALPHA_CHANGED',
  SELECTED_IMAGE_NUMBER_CHANGED: 'SELECTED_IMAGE_NUMBER_CHANGED',
  EXPORT_SCENE_IMAGE: 'EXPORT_SCENE_IMAGE',
  ZOOM_BUTTON_CHANGE: 'ZOOM_BUTTON_CHANGE',
  CHANGE_CROP_VISIBILITY: 'CHANGE_CROP_VISIBILITY',
  FIT_TO_SCREEN: 'FIT_TO_SCREEN',
  MOVE_TO_SELECTED_CROP: 'MOVE_TO_SELECTED_CROP'
};

export default new Vue({
  data() {
    return {
      ValidatedCrops: {
        isLoading: false,
        isLoaded: false,
        hasError: false,
        data: {
          body: []
        }
      },
      VisitSkuValidation: {
        isLoading: false,
        isLoaded: false,
        hasError: false,
        data: {}
      },
      referenceVisitSkuValidation: {
        isLoading: false,
        isLoaded: false,
        hasError: false,
        data: {}
      },
      show_meta_sku: true,
      show_unrecognized_sku: true,
      show_normal_sku: true,
      show_non_sku: true,
      hide_competitor_sku: true,
      selected_crop: null,
      projectId: '',
      visitId: '',
      missingList: [],
      misplacedList: [],
      excessList: [],
      outOfStockList: [],
      inStockList: [],
      isFilledCrop: false,
      viewRecognitionResult: false,
      selectedLegends: [
        {
          name: 'Out Of Stock',
          mobileName: 'OOS',
          id: 'out_of_stock',
          color: '#ff4444',
          line_color: 0xff4444,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Missing'),
          id: 'missing',
          color: '#f9cb49',
          line_color: 0xf9cb49,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Misplaced'),
          id: 'misplaced',
          color: '#6efff1',
          line_color: 0x6efff1,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Excess'),
          id: 'excess',
          color: '#76ff5f',
          line_color: 0x76ff5f,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Unrecognized'),
          id: 'unrecognized',
          color: '#777777',
          line_color: 0x777777,
          isChecked: true,
          show: false
        }
      ],
      selectedClasses: [
        {
          name: i18n.t('My Sku'),
          id: 'sku',
          color: '#fcee22',
          line_color: 0xfcee22,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Competitor Sku'),
          id: 'competitor_sku',
          color: '#c729ff',
          line_color: 0xc729ff,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Price Tag'),
          id: 'price_tag',
          color: '#6efff1',
          line_color: 0x6efff1,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Other Classes'),
          id: 'other_classes',
          color: '#8cc1ff',
          line_color: 0x8cc1ff,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Unrecognized'),
          id: 'unrecognized',
          color: '#777777',
          line_color: 0x777777,
          isChecked: true,
          show: false
        }
      ],
      // sceneZoomScaleValue: 0.4,
      sceneZoomScaleValue: {
        realogram: 0.4,
        planogram: 0.4
      },
      isFilterSelected: false,
      updatedSkuList: [],
      skuListForPixiLoader: [],
      dragPositionForRealogram: { x: 0, y: 0 },
      dragPositionForPlanogram: { x: 0, y: 0 },
      selectedScene: i18n.t('Realogram'),
      imageSetTypes: ['DetectionReadingTaskResult', 'DetectionTaskResult', 'RectifiedDetectionTaskResult'],
      selectedMisplacedSkuId: null,
      realogramSceneFitScaleValue: null
    };
  },
  methods: {
    toggleSkuByType() {
      this.$emit(EVENTS.TOGGLE_SKU_BY_TYPE);
    }
  }
});
